module.exports = __webpack_public_path__ + "static/media/dadMotorcyclePurple.666284f0.gif";